"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _classnames = _interopRequireDefault(require("../Dialog/classnames"));
var _excluded = ["className", "dividers", "paddingTop", "paddingBottom"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var styles = {
  "contentWrapper": "Bkz91b",
  "dividers": "ddpWoa"
};
var getClassName = function getClassName(_ref) {
  var className = _ref.className,
    dividers = _ref.dividers;
  return (0, _clsx["default"])(className, _classnames["default"].DIALOG_CONTENT, styles.contentWrapper, dividers && styles.dividers);
};
var getStyle = function getStyle(_ref2) {
  var paddingBottom = _ref2.paddingBottom,
    paddingTop = _ref2.paddingTop;
  return _objectSpread(_objectSpread({}, paddingBottom !== undefined && {
    '--padding-bottom': paddingBottom
  }), paddingTop !== undefined && {
    '--padding-top': paddingTop
  });
};
var DialogContent = function DialogContent(_ref3) {
  var className = _ref3.className,
    dividers = _ref3.dividers,
    paddingTop = _ref3.paddingTop,
    paddingBottom = _ref3.paddingBottom,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], _extends({
    className: getClassName({
      className: className,
      dividers: dividers
    }),
    dividers: dividers,
    style: getStyle({
      paddingBottom: paddingBottom,
      paddingTop: paddingTop
    })
  }, props));
};
DialogContent.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  dividers: _propTypes["default"].bool,
  paddingTop: _propTypes["default"].string,
  paddingBottom: _propTypes["default"].string
} : {};
var _default = exports["default"] = DialogContent;